(function($) {
    $(document).ready(function($) {
        const nav = document.getElementById('main-nav');
        const topbar = document.querySelector('.ft-topbar');
        if (nav) {
            // "scrolled" hace falta en TODAS las páginas (blanco o transparente):
            // es lo que hace que el nav pase a ocupar top:0 y que la topbar (fixed,
            // se solapa con el hero — ver .ft-topbar en _child_theme.scss) se
            // oculte, en vez de quedarse flotando encima del contenido para
            // siempre. El cambio de navbar-dark/-light, en cambio, solo tiene
            // sentido en el nav transparente sobre el Hero.
            const navIsTransparent = nav.classList.contains('ft-nav-transparent');
            $(window).on('scroll', function() {
                if ($(this).scrollTop() > 50) {
                    $(nav).addClass('scrolled');
                    if (topbar) $(topbar).addClass('scrolled');
                    // El fondo pasa a blanco al hacer scroll, así que el texto tiene que
                    // pasar de navbar-dark (claro, para el Hero) a navbar-light (oscuro).
                    if (navIsTransparent) {
                        $(nav).removeClass('navbar-dark').addClass('navbar-light');
                    }
                } else {
                    $(nav).removeClass('scrolled');
                    if (topbar) $(topbar).removeClass('scrolled');
                    if (navIsTransparent) {
                        $(nav).removeClass('navbar-light').addClass('navbar-dark');
                    }
                }
            });
        }

        // Featured tours: la flecha desplaza el carril horizontal una tarjeta a la vez.
        $('.ft-featured-tours__arrow').on('click', function() {
            const $track = $(this).siblings('.ft-featured-tours__track');
            if (!$track.length) return;

            const $card = $track.find('.ft-tour-card').first();
            const scrollAmount = $card.length ? $card.outerWidth(true) : 320;

            $track.animate({ scrollLeft: '+=' + scrollAmount }, 400);
        });

        // Featured tours (home): oculta cualquier pill cuya categoría no tenga
        // ninguna tarjeta cargada entre los tours destacados (no debería pasar, ya
        // que los pills salen de las categorías reales de esas tarjetas, pero por
        // si acaso). Acotado a #featured-tours para no afectar a otras páginas que
        // reutilicen la misma clase de pill (p. ej. el filtro por tag de taxonomía).
        $('#featured-tours .ft-featured-tours__pill[data-ft-filter]').not('[data-ft-filter="all"]').each(function() {
            const filter = $(this).data('ft-filter');
            const hasMatch = $('#featured-tours .ft-tour-card').toArray().some(function(card) {
                return ($(card).data('ft-categories') || '').toString().split(' ').includes(filter);
            });

            if (!hasMatch) {
                $(this).hide();
            }
        });

        // Featured tours (home): los pills filtran las tarjetas ya cargadas en la
        // página, no enlazan a otro sitio. El cambio se anima con fundido.
        const FT_FADE_MS = 400; // debe coincidir con la transition de .ft-tour-card en SCSS

        $('#featured-tours .ft-featured-tours__pill').on('click', function() {
            const $pill = $(this);
            const filter = $pill.data('ft-filter');

            $pill.siblings('.ft-featured-tours__pill').removeClass('active').attr('aria-pressed', 'false');
            $pill.addClass('active').attr('aria-pressed', 'true');

            $('#featured-tours .ft-tour-card').each(function() {
                const card = this;
                const categories = ($(card).data('ft-categories') || '').toString().split(' ');
                const matches = filter === 'all' || categories.includes(filter);

                // La tarjeta lleva la utility d-flex de Bootstrap (display:flex !important),
                // así que hay que forzar el !important a mano al ocultarla (ver más abajo).
                if (matches) {
                    // Recupera el layout ya, pero deja la tarjeta transparente/encogida un
                    // frame más para que la transición de opacidad se vea al quitarle la clase.
                    card.style.removeProperty('display');
                    void card.offsetWidth; // fuerza reflow, si no el navegador no anima el cambio
                    card.classList.remove('ft-tour-card--hidden');
                } else {
                    card.classList.add('ft-tour-card--hidden');
                    setTimeout(function() {
                        if (card.classList.contains('ft-tour-card--hidden')) {
                            card.style.setProperty('display', 'none', 'important');
                        }
                    }, FT_FADE_MS);
                }
            });
        });

        // Listado por taxonomía (taxonomy-portfolio_entries.php): los pills de tag
        // filtran vía AJAX (el propio servidor decide qué tours encajan), con
        // fundido de la rejilla mientras llega la respuesta.
        const $ftTagFilter = $('#ft-tag-filter');

        if ($ftTagFilter.length) {
            $ftTagFilter.on('click', '.ft-featured-tours__pill', function() {
                const $pill = $(this);
                const tag = $pill.data('ft-tag');
                const termId = $ftTagFilter.data('ft-term-id');
                const $grid = $('#ft-tour-grid');

                if (!$grid.length || $pill.hasClass('active')) return;

                $pill.siblings('.ft-featured-tours__pill').removeClass('active').attr('aria-pressed', 'false');
                $pill.addClass('active').attr('aria-pressed', 'true');

                $grid.stop(true).animate({ opacity: 0 }, 200, function() {
                    $.post(myAjax.ajaxUrl, {
                        action: 'ft_filter_by_tag',
                        nonce: myAjax.filterNonce,
                        tag_slug: tag,
                        taxonomy_term_id: termId
                    }).done(function(response) {
                        if (response && response.success) {
                            $grid.html(response.data.html);
                        }
                    }).always(function() {
                        $grid.animate({ opacity: 1 }, 300);
                    });
                });
            });
        }

        // Página de tag (taxonomy-portfolio_tags.php): enlace "‹ Volver" solo si el
        // visitante llegó desde otra página del mismo sitio (evita un enlace roto o
        // engañoso si llega desde Google o un enlace externo) y no es la misma URL.
        const $backLink = $('#ft-back-link');
        if ($backLink.length && document.referrer) {
            try {
                const referrer = new URL(document.referrer);
                if (referrer.origin === window.location.origin && referrer.href !== window.location.href) {
                    $backLink.html(
                        $('<a>', {
                            href: referrer.href,
                            class: 'text-white text-decoration-none small d-inline-flex align-items-center gap-1',
                            html: '<i class="fa fa-chevron-left" aria-hidden="true"></i> ' + (typeof myAjax !== 'undefined' ? myAjax.backLinkText : 'Back')
                        })
                    );
                }
            } catch (e) {
                // document.referrer no es una URL válida — no se muestra el enlace.
            }
        }

    });

    // Widget de reviews de Trustindex.io ([trustindex no-registration=tripadvisor]):
    // por ahora solo se limita a las 3 primeras reviews, sin botón "Load more"
    // (el plugin gratuito no lo soporta bien — pendiente de resolver con otro
    // proveedor de reviews más adelante).
    //
    // El propio <div class="ti-widget"> lo inserta en el DOM el script remoto de
    // Trustindex (cdn.trustindex.io), de forma asíncrona y sin garantía de que
    // ocurra antes de que jQuery dispare "ready" — por eso este bloque va en JS
    // plano, fuera de $(document).ready(), observando todo el <body> hasta que
    // aparezca el widget en sí (no solo su contenido).
    (function() {
        const FT_TI_VISIBLE = 3;
        const ftTiLimited = new WeakSet();

        function ftLimitTrustindexWidget(widget) {
            if (ftTiLimited.has(widget)) return;

            const wrapper = widget.querySelector('.ti-reviews-container-wrapper');
            if (!wrapper) return;

            function applyLimit() {
                const items = Array.prototype.filter.call(
                    wrapper.children,
                    function(el) { return el.classList.contains('ti-review-item'); }
                );
                if (!items.length) return false;

                items.forEach(function(item, i) {
                    item.style.display = i < FT_TI_VISIBLE ? '' : 'none';
                });
                return true;
            }

            // Las reviews en sí pueden llegar en un segundo paso async (contenedor
            // ya insertado, contenido todavía no) — se reintenta hasta que haya
            // contenido, y luego se deja de observar ese widget.
            if (applyLimit()) {
                ftTiLimited.add(widget);
                return;
            }

            const itemsObserver = new MutationObserver(function() {
                if (applyLimit()) {
                    ftTiLimited.add(widget);
                    itemsObserver.disconnect();
                }
            });
            itemsObserver.observe(wrapper, { childList: true });
        }

        function ftScanForTrustindexWidgets(root) {
            if (root.classList && root.classList.contains('ti-widget')) {
                ftLimitTrustindexWidget(root);
            }
            if (root.querySelectorAll) {
                root.querySelectorAll('.ti-widget').forEach(ftLimitTrustindexWidget);
            }
        }

        ftScanForTrustindexWidgets(document.body);

        const ftBodyObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        ftScanForTrustindexWidgets(node);
                    }
                });
            });
        });
        ftBodyObserver.observe(document.body, { childList: true, subtree: true });
    })();
})(jQuery);